import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

import { FormState, cleanNumericalString } from '@shared';

import { SmsCredits } from '@account-users/account/models/SmsCredits';
import { PatchSmsCreditsPayload } from '@account-users/account/models/PatchSmsCreditsPayload';
import { Permission } from '@account-users/account/models/Permission';

@Component({
  selector: 'app-sms-credits',
  templateUrl: './sms-credits.component.html',
  styleUrls: ['./sms-credits.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SmsCreditsComponent implements OnInit {
  @Input() userPermissions: Permission[] = [];
  @Input() isUpdatingSmsCredits: boolean;
  @Input() currentSmsCredits: SmsCredits;
  @Output() updateSmsCredits = new EventEmitter<PatchSmsCreditsPayload>();

  form: FormGroup;
  FormState = FormState;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      smsCredits: this.fb.control(
        {
          value: '',
          disabled: !this.canPlaceOrders,
        },
        [Validators.required, Validators.maxLength(11)],
      ),
      orderId: this.fb.control({ value: '', disabled: !this.canPlaceOrders }, [
        Validators.required,
        Validators.pattern(/^[A-Za-z0-9]{16}$/),
      ]),
    });
  }

  get disabledSubmit() {
    return (
      !this.canPlaceOrders || this.isUpdatingSmsCredits || this.form.invalid
    );
  }

  get smsCredits() {
    return this.form.get('smsCredits') as FormControl;
  }

  get orderId() {
    return this.form.get('orderId') as FormControl;
  }

  get canPlaceOrders() {
    return this.userPermissions.includes(Permission.CanPlaceOrders);
  }

  get isCreditsValid() {
    return (
      parseInt(cleanNumericalString(this.smsCredits.value), 10) <= 999999999
    );
  }

  onSubmit($event: Event) {
    $event.preventDefault();

    if (this.form.valid && this.smsCredits.touched && this.isCreditsValid) {
      this.updateSmsCredits.emit({
        addCredits: parseInt(cleanNumericalString(this.smsCredits.value), 10),
        orderId: this.orderId.value,
      });

      this.orderId.reset();
      this.smsCredits.reset();
    }
  }
}
